import { View, Text } from "@react-pdf/renderer";
import { styles } from "./styles/styles";
import { prepStepStyles } from "./styles/prepStepStyles";
import { StepZutat } from "@/types/baseTypes";
import { stripHtmlTags } from "@/utils/glossary/stripHtmlTags.ts";

export const TablePdfIngredients = ({
  ingredientList,
  currentStepDescrArray,
  stepCat,
}: {
  ingredientList: StepZutat[];
  currentStepDescrArray: string[] | null;
  stepCat?: string;
}) => {
  const checkboxEmptyRegex = /◎/g;
  const checkboxFilledRegex = /◉/g;

  return (
    <View style={prepStepStyles.ingredients}>
      {ingredientList?.map((ingredient, i) => {
        return (
          <View key={i} style={prepStepStyles.ingredientRow}>
            <View key={i} style={prepStepStyles.ingredientLeft}>
              <Text style={styles.textRegular}>{`${
                ingredient.step_zutat_menge !== 0
                  ? ingredient.step_zutat_menge + " "
                  : ""
              }${ingredient.step_zutat_masseinheit_abkuerzung}`}</Text>
            </View>
            <View style={prepStepStyles.ingredientRight}>
              {ingredient.zutat_namen && ingredient.zutat_namen.length > 0 && (
                <Text style={styles.textRegular}>
                  {stripHtmlTags(ingredient.zutat_namen)}{" "}
                </Text>
              )}
              {ingredient.step_zutat_freitext &&
                ingredient.step_zutat_freitext.length > 0 && (
                  <Text style={styles.textRegular}>
                    {ingredient.step_zutat_freitext
                      ?.replace(/<[^>]*>/g, "")
                      .replace("&nbsp;", " ")
                      .replace("\n", "")}
                  </Text>
                )}
            </View>
            {i === ingredientList?.length - 1 ? (
              <View style={prepStepStyles.directions}>
                {currentStepDescrArray
                  ? currentStepDescrArray.map((descriptionItem, i) => (
                      <Text style={styles.textRegular} key={i}>
                        {descriptionItem
                          .replace(/<[^>]+>/g, "")
                          .trim()
                          .replace(/\s+/g, " ")
                          .replace(checkboxEmptyRegex, "( )")
                          .replace(checkboxFilledRegex, "(x)")
                          .replace("&nbsp;", " ")
                          .replace("\n", "")}
                      </Text>
                    ))
                  : null}
                {stepCat ? (
                  <View>
                    {stepCat
                      .replace(/<[^>]*>/g, "")
                      .replace("&nbsp;", " ")
                      .replace("\n", "")}
                  </View>
                ) : null}
              </View>
            ) : (
              <View style={prepStepStyles.directions}></View>
            )}
          </View>
        );
      })}
    </View>
  );
};
